import React from "react";
import { FilePreview } from "@/components/FilePreview";
import { Card } from "@/components/Card";
import { useTheme } from "@/hooks/useTheme";
import { Button } from "@/components/Button";

interface IProps {
  file: File;
  onRepairBtnClick: () => void;
}

export const Preview: React.FC<IProps> = props => {
  const { file, onRepairBtnClick } = props;
  const { bp } = useTheme();

  return (
    <FilePreview file={file}>
      <Card
        customStyle={{
          marginTop: 25,
          marginBottom: -6,
          boxShadow: "0 2px 22px 0 rgba(0, 0, 0, 0.08)",
          [bp.FROM_TABLET]: {
            padding: "28px 30px 28px 30px",
          },
          nested: {
            "> div:not(:first-of-type)": {
              marginTop: 20,
            },
          },
        }}
      >
        <Button onClick={onRepairBtnClick}>Repair file</Button>
      </Card>
    </FilePreview>
  );
};
